export const theme = {
  primaryPeach: 'rgba(231, 129, 107, 1)',
  primaryBlack: ' rgba(29, 28, 30, 1)',
  primaryWhite: ' rgba(255, 255, 255, 1)',
  secondaryPeach: 'rgba(255, 173, 155, 1)',
  secondaryLigthPeach: '#FDF3F0',
  secondaryDarkGray: 'rgba(51, 49, 54, 1)',
  secondaryLigthGray: ' rgba(241, 243, 245, 1)',
  transparent: 'rgba(255, 255, 255, 0)',
  radius: '8px',
  fontSize: {
    l: '24px',
    m: '16px',
    s: '14px',
  },
  familiy: {
    jost: '"Jost", "sans-serif"',
  },
  mq: {
    btwMobileDesktop: '@media (min-width: 768px) and (max-width: 1024px)',
    tablet: '@media (min-width: 768px)',
    desktop: '@media (min-width: 1024px)',
    bigDestop: '@media (min-width: 1280px)',
  },
};
